import gql from 'graphql-tag';
import { clients } from '../../util/clients';

const { backend } = clients.direct;

const isConfigured = (config) => {
  if (
    config.apiAccessId
    && config.locationId
  ) {
    return true;
  }
  return false;
};

export const ForteService = {
  namespaced: true,
  state: () => ({
    forteConfig: {},
    forteResponse: {},
    forteIndex: -1,
    fortePaymentSuscessFlag: false,
    // One raw Forte response per successful charge, so a payment split across multiple
    // cards can create a CC record for EVERY card. forteResponse above only ever holds
    // the LAST charged card; this list keeps them all. Deduped by trace_number; cleared
    // after a successful save and when a fresh payment begins.
    capturedForteResponses: [],
  }),
  mutations: {
    setConfigData(state, config) {
      state.forteConfig = config;
    },
    setForteResponse(state, config) {
      state.forteResponse = config;
    },
    addCapturedForteResponse(state, response) {
      // Accumulate each charge's response. Dedupe by the Forte trace_number so a re-fired
      // success callback can't produce a duplicate CC record.
      if (!response || !response.trace_number) return;
      const alreadyCaptured = state.capturedForteResponses
        .some((existing) => existing.trace_number === response.trace_number);
      if (!alreadyCaptured) {
        state.capturedForteResponses = [...state.capturedForteResponses, response];
      }
    },
    clearCapturedForteResponses(state) {
      state.capturedForteResponses = [];
    },
    setFortePaymentSuccessFlag(state, flag) {
      state.fortePaymentSuscessFlag = flag;
    },
    setForteIndex(state, index) {
      state.forteIndex = index;
    },
  },
  actions: {
    async fetchForteConfig({ dispatch, commit }, { scope, forteAmount }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        const amount = (forteAmount || '').toString();
        results = await backend.query({
          query: gql` query fetchForteConfig($scope: String, $amount: String) {
            forteCheckoutData(scope: $scope, amount: $amount) { scope, configData }
          }`,
          variables: { scope, amount },
          fetchPolicy: 'no-cache',
        });
        // console.log(results);
        const response = { ...results.data.forteCheckoutData.configData };
        response.isConfigured = isConfigured(response);
        commit('setConfigData', response);
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem loading Configs.', { root: true });
      }
    },
    setForteResponse({ commit }, response) {
      commit('setForteResponse', response);
      // Capture alongside the singleton so every charged card survives to save time.
      commit('addCapturedForteResponse', response);
    },
    clearCapturedForteResponses({ commit }) {
      commit('clearCapturedForteResponses');
    },
    setFortePaymentSuccessFlag({ commit }, flag) {
      commit('setFortePaymentSuccessFlag', flag);
    },
  },
};

export default ForteService;
